var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3599 1.51241C11.9862 1.1825 11.5016 1 10.9993 1C10.497 1 10.0124 1.1825 9.63878 1.51241L2.1745 8.10341C1.96227 8.29095 1.79255 8.52026 1.67635 8.77645C1.56015 9.03263 1.50007 9.30997 1.5 9.59045V18.9995C1.5 19.5301 1.71448 20.0389 2.09625 20.4141C2.47802 20.7892 2.99581 21 3.53571 21H6.25C6.7899 21 7.3077 20.7892 7.68947 20.4141C8.07124 20.0389 8.28571 19.5301 8.28571 18.9995V13.6648C8.28571 13.488 8.35721 13.3183 8.48446 13.1933C8.61172 13.0682 8.78432 12.998 8.96429 12.998H13.0357C13.2157 12.998 13.3883 13.0682 13.5155 13.1933C13.6428 13.3183 13.7143 13.488 13.7143 13.6648V18.9995C13.7143 19.5301 13.9288 20.0389 14.3105 20.4141C14.6923 20.7892 15.2101 21 15.75 21H18.4643C19.0042 21 19.522 20.7892 19.9038 20.4141C20.2855 20.0389 20.5 19.5301 20.5 18.9995V9.59045C20.4999 9.30997 20.4399 9.03263 20.3236 8.77645C20.2074 8.52026 20.0377 8.29095 19.8255 8.10341L12.3612 1.51241H12.3599Z",
    stroke: "#241A0F",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1f29be112b5c3ecb743262389a90e4f8.svg";
export { ForwardRef as ReactComponent };